import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StateContactUsParams } from "../types/contactUs/contactUsParams";

interface ContactUsInitialStateParams {
    isLoading: boolean;
    getAllContactUs: StateContactUsParams[];
    searchContactUs: StateContactUsParams[];
    currentPage: number;
    numberOfPages: number;
    totalNumber: number;
    singleContactUs: StateContactUsParams | null;
    deleteContactUs: StateContactUsParams[] | null;
}

const initialState: ContactUsInitialStateParams = {
    isLoading: true,
    getAllContactUs: [],
    searchContactUs: [],
    currentPage: 1,
    numberOfPages: 0,
    totalNumber: 0,
    singleContactUs: null,
    deleteContactUs: null,
}

const contactUsSlice = createSlice({
    name: 'CONTACT_US',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setContactUs: (state, action: PayloadAction<{
            data: StateContactUsParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.getAllContactUs         = action.payload.data;
            state.currentPage         = action.payload.currentPage;
            state.numberOfPages       = action.payload.numberOfPages;
            state.totalNumber         = action.payload.totalNumber;
        },
        setSingleContactUs: (state, action: PayloadAction<StateContactUsParams>) => {
            state.singleContactUs          = action.payload;
        },
        setContactUsSearch: (state, action: PayloadAction<{
            data: StateContactUsParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.searchContactUs          = action.payload.data;
            state.currentPage         = action.payload.currentPage
            state.numberOfPages       = action.payload.numberOfPages
            state.totalNumber         = action.payload.totalNumber
        },
        setDeleteContactUs: (state, action: PayloadAction<string>) => {
            state.deleteContactUs = state.getAllContactUs.filter((result) => result._id !== action.payload);
        }
    }
});

export const { startLoading, endLoading, setContactUs, setSingleContactUs, setContactUsSearch, setDeleteContactUs } = contactUsSlice.actions
export default contactUsSlice.reducer
